import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants';
import {
  AutAthMgtGetMotpPinNumRequest,
  AutAthMgtGetMotpPinNumResponse,
} from '../../types/api/autAthMgtGetMotpPinNum';
import {
  AutVrfTknActivateRequest,
  AutVrfTknActivateResponse,
} from '../../types/api/autVrfTknActivate';
import {
  AutVrfTknSelectMotpDeviceStatusRequest,
  AutVrfTknSelectMotpDeviceStatusResponse,
} from '../../types/api/autVrfTknSelectMotpDeviceStatus';
import { AutVrfTknSendMotpPushResponse } from '../../types/api/autVrfTknSendMotpPush';

/**
 * 보안매체 초기화
 * @param mutationOptions
 * @returns
 */
export function useAutVrfTknActivate(
  mutationOptions?: UseRestPostMutationOptions<AutVrfTknActivateRequest, AutVrfTknActivateResponse>,
) {
  return useRestPost<AutVrfTknActivateRequest, AutVrfTknActivateResponse>(
    {
      endpoint: APIS.auth.verification.tokens.activate,
    },
    mutationOptions,
  );
}

/**
 * 모바일OTP PIN번호 확인
 */
export const useAutAthMgtGetMotpPinNum = (
  mutationOptions?: UseRestPostMutationOptions<
    AutAthMgtGetMotpPinNumRequest,
    AutAthMgtGetMotpPinNumResponse
  >,
) => {
  return useRestPost<AutAthMgtGetMotpPinNumRequest, AutAthMgtGetMotpPinNumResponse>(
    {
      endpoint: APIS.auth.authenticator.management.getMotpPinNum,
    },
    mutationOptions,
  );
};

/**
 * MOTP 기기상태 조회
 * @param mutationOptions
 * @returns
 */
export const useAutVrfTknSelectMotpDeviceStatus = (
  mutationOptions?: UseRestPostMutationOptions<
    AutVrfTknSelectMotpDeviceStatusRequest,
    AutVrfTknSelectMotpDeviceStatusResponse
  >,
) => {
  return useRestPost<
    AutVrfTknSelectMotpDeviceStatusRequest,
    AutVrfTknSelectMotpDeviceStatusResponse
  >(
    {
      endpoint: APIS.auth.verification.tokens.selectMotpDeviceStatus,
    },
    mutationOptions,
  );
};
/**
 * MOTP push 발송
 * @param mutationOptions
 * @returns
 */
export const useAutVrfTknSendMotpPush = (
  mutationOptions?: UseRestPostMutationOptions<void, AutVrfTknSendMotpPushResponse>,
) => {
  return useRestPost<void, AutVrfTknSendMotpPushResponse>(
    {
      endpoint: APIS.auth.verification.tokens.sendMotpPush,
    },
    mutationOptions,
  );
};
